import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  Header,
  Paragraph
} from '@eggplant/pattern-library'
import { testConfig } from '../../docs-routes'

const TestConfigMaxRunTimeDescription = () =>
  <>
    <Header
      hasNoTopMargin
      rank={4}
    >
      Max run time
    </Header>
    <Paragraph>
      Test runs exceeding max run time are automatically cancelled to manage SUT availability and prevent stuck jobs. This value is configurable by system administrators.
    </Paragraph>
    <br />
    <LinkToDocusaurus path={testConfig}>
      Learn more in the DAI documentation
    </LinkToDocusaurus>
  </>

export default TestConfigMaxRunTimeDescription
